import axios from "axios";
import {
  STATUS_PATH,
  dependencyLabel,
} from "../config/servicesStatus";

const STATUS_TIMEOUT_MS = 15000;

const STATUS_TENANT_ID = "tnt_IjvUGLPhovxmKGs";

export const STATUS_LEVELS = {
  HEALTHY: "Healthy",
  DEGRADED: "Degraded",
  UNHEALTHY: "Unhealthy",
  UNKNOWN: "Unknown",
};

const buildAuthHeaders = () => {
  const token = localStorage.getItem("authToken");
  if (!token) return {};
  return {
    Authorization: `Bearer ${token}`,
    "t-api-key": token,
  };
};

const toNumberOrNull = (value) =>
  typeof value === "number" && Number.isFinite(value) ? value : null;

const mapDependencies = (dependencies) =>
  (Array.isArray(dependencies) ? dependencies : []).map((dependency) => ({
    name: dependency?.name ?? "unknown",
    label: dependencyLabel(dependency?.name),
    status: dependency?.status || STATUS_LEVELS.UNKNOWN,
    description: dependency?.description ?? null,
    durationMs: toNumberOrNull(dependency?.durationMs),
  }));

const placeholderDependencies = (service) =>
  (service.expectedDependencies || []).map((name) => ({
    name,
    label: dependencyLabel(name),
    status: STATUS_LEVELS.UNKNOWN,
    description: null,
    durationMs: null,
  }));

const describeError = (error) => {
  if (error?.code === "ECONNABORTED") return "Request timed out";
  if (error?.response) {
    return `HTTP ${error.response.status}${
      error.response.statusText ? ` ${error.response.statusText}` : ""
    }`;
  }
  if (error?.message) return error.message;
  return "Unreachable";
};

const normalizeStatus = (service, data, url) => ({
  key: service.key,
  name: data?.service || service.name,
  url,
  note: service.note ?? null,
  reachable: true,
  status: data?.status || STATUS_LEVELS.UNKNOWN,
  version: data?.version ?? null,
  timestamp: data?.timestamp ?? null,
  totalDurationMs: toNumberOrNull(data?.totalDurationMs),
  dependencies: mapDependencies(data?.dependencies),
  error: null,
});

const buildUnreachableResult = (service, url, error) => ({
  key: service.key,
  name: service.name,
  url,
  note: service.note ?? null,
  reachable: false,
  status: STATUS_LEVELS.UNHEALTHY,
  version: null,
  timestamp: null,
  totalDurationMs: null,
  dependencies: placeholderDependencies(service),
  error: describeError(error),
});

export const fetchServiceStatus = async (service) => {
  const url = `${service.baseUrl}${STATUS_PATH}`;
  try {
    const { data } = await axios.get(url, {
      headers: { ...buildAuthHeaders(), tenantId: STATUS_TENANT_ID },
      timeout: STATUS_TIMEOUT_MS,
    });
    return normalizeStatus(service, data, url);
  } catch (error) {
    return buildUnreachableResult(service, url, error);
  }
};

export const fetchAllServiceStatuses = (services) =>
  Promise.all(services.map((service) => fetchServiceStatus(service)));
